import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { Divider } from '@material-ui/core';
import { Header, Price, Buttons, Ratings, OpenNow, AddSortBy } from '../../components';
import styles from './styles';

class Filter extends React.PureComponent {
  render() {
    const { t, classes } = this.props;
    return (
      <React.Fragment>
        <Header title={t('filter.label.title')} />
        <Divider />
        <span className={classes.scroll__wheel}>
          <span className={classes.padding}>
            <Price />
          </span>
          <span className={classes.padding}>
            <Ratings />
          </span>
          <OpenNow />
          <AddSortBy />
        </span>
        <Buttons />
      </React.Fragment>
    );
  }
}

Filter.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(Filter));
